import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    AanslagBtw, AanslagIb, AanslagVpb, AanslagZwv, BerichtenService, BeschikkingsType, BokkzAlgDataService, Mededeling,
    OphaalResponse, ToeslagType
} from '@snelstart-ventures/fiscaal/domain-logic';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastService } from '@snelstart/ui-toast';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'snelstart-venture-fiscaal-sba',
    standalone: true,
    imports: [CommonModule, SharedUiDetailsModule, SharedUiFormControlsModule, SharedUiButtonModule],
    templateUrl: './sba.component.html',
    styleUrl: './sba.component.scss'
})
export class SbaComponent implements OnInit, OnDestroy {

    @Input() public id!: string;
    private destroy$ = new Subject<void>();
    public serviceBerichtXbrl = {} as string;
    public sbaIb = {} as AanslagIb;
    public sbaZvw = {} as AanslagZwv;
    public sbaVpb = {} as AanslagVpb;
    public sbaBtw = {} as AanslagBtw;
    public sbaTsl = {} as Mededeling;
    public isIb = false;
    public isZvw = false;
    public isVpb = false;
    public isBtw = false;
    public isTsl = false;
    public formGroupIb = <FormGroup>{};
    public formGroupZvw = <FormGroup>{};
    public formGroupVpb = <FormGroup>{};
    public formGroupBtw = <FormGroup>{};
    public formGroupTsl = <FormGroup>{};

    constructor(
        public algDataService: BokkzAlgDataService,
        public toastService: ToastService,
        public berichtenService: BerichtenService,
        public fb: FormBuilder
    ) {
        this.formGroupIb = this.fb.group({
            belastbaarInkomenUitWerkEnWoning: null as unknown as number,
            inkomstenbelastingBox1: null as unknown as number,
            belastingBox1: null as unknown as number,
            saldoPremiesVolksverzekeringen: null as unknown as number,
            belastbaarInkomenAanmerkelijkBelang: null as unknown as number,
            belastingBox2: null as unknown as number,
            belastbaarInkomenBox3: null as unknown as number,
            rendementsGrondslagVermogensToets: null as unknown as number,
            belastingBox3: null as unknown as number,
            algemeneHeffingskortingBerekend: null as unknown as number,
            arbeidsKortingBerekend: null as unknown as number,
            inkomensafhankelijkeCombinatiekortingBerekend: null as unknown as number,
            jonggehandicaptenkortingBerekend: null as unknown as number,
            ouderenKortingBerekend: null as unknown as number,
            alleenstaandeOuderenKortingBerekend: null as unknown as number,
            groeneBeleggingenKortingBerekend: null as unknown as number,
            nietUitbetaalbaaDeelHeffingskortingen: null as unknown as number,
            heffingskorting: null as unknown as number,
            uitbetalingHeffingskortingen: null as unknown as number,
            verzamelinkomen: null as unknown as number,
            bedragVanDeAanslagNaToetsingAanslaggrens: null as unknown as number,
            bedragVanDeAanslagInclNegatieveVoorlopigeAanslag: null as unknown as number,
            eerderVastgesteldBedrag: null as unknown as number,
            eerderVastgesteldeNavordering: null as unknown as number,
            eerderVerleendeVoorlopigeTeruggaven: null as unknown as number,
            bedragAanslagMetRente: null as unknown as number,
            totaalEerdereAanslagen: null as unknown as number,
            bedragAanslagEerder: null as unknown as number,
            vorigBedragAanslagMetRente: null as unknown as number,
            nieuwBedragVanDeVoorlopigeAanslag: null as unknown as number,
            vergrijpBoete: null as unknown as number,
            verzuimBoete: null as unknown as number,
            belastingrenteInEerdereAanslagen: null as unknown as number,
            belastingrenteBerekend: null as unknown as number,
            belastingrenteInRekeningGebracht: null as unknown as number,
            vergoedeBelastingrente: null as unknown as number,
            verminderingInRekeningGebrachteBelastingrente: null as unknown as number,
            revisierente: null as unknown as number,
            saldoExclusiefVergoedeBelastingrente: null as unknown as number,
            saldoEerdereAanslagenExclVergoedeBelastingrente: null as unknown as number,
            teBetalenTerugTeOntvangen: null as unknown as number,
            verrekendeDividendEnKansspelbelasting: null as unknown as number,
            teVerrekenenLoonbelastingPremieVolksverzekeringen: null as unknown as number,
            naw1Belastingplichtige: null as unknown as string,
            middel: null as unknown as string,
            aangifteJaar: null as unknown as number
        });
        this.formGroupZvw = this.fb.group({
            uitersteDatumBezwaar: null as unknown as Date,
            uitersteDatumBeroep: null as unknown as Date,
            bijdrageInkomenAanslagZVW: null as unknown as number,
            loonZorgverzekeringswet: null as unknown as number,
            toegepastBijdrageInkomenZVW: null as unknown as number,
            toegepastMaximumBijdrageInkomenZVW: null as unknown as number,
            bijdrageZvwAanslag: null as unknown as number,
            eerderVastgesteldBedrag: null as unknown as number,
            bedragAanslagMetRente: null as unknown as number,
            totaalEerdereAanslagen: null as unknown as number,
            bedragAanslagEerder: null as unknown as number,
            vorigBedragAanslagMetRente: null as unknown as number,
            nieuwBedragVanDeVoorlopigeAanslag: null as unknown as number,
            vergrijpBoete: null as unknown as number,
            belastingrenteInEerdereAanslagen: null as unknown as number,
            belastingrenteBerekend: null as unknown as number,
            belastingrenteInRekeningGebracht: null as unknown as number,
            vergoedeBelastingrente: null as unknown as number,
            verminderingInRekeningGebrachteBelastingrente: null as unknown as number,
            saldoExclusiefVergoedeBelastingrente: null as unknown as number,
            saldoEerdereAanslagenExclVergoedeBelastingrente: null as unknown as number,
            teBetalenTerugTeOntvangen: null as unknown as number,
            naw1Belastingplichtige: null as unknown as string,
            middel: null as unknown as string,
            aangifteJaar: null as unknown as number
        });
        this.formGroupVpb = this.fb.group({
            belastbareWinst: null as unknown as number,
            verrekendVerliesDitBoekjaar: null as unknown as number,
            belastbaarBedrag: null as unknown as number,
            belastbaarBedragInFunctioneleValuta: null as unknown as number,
            aftrekBeperkingRente: null as unknown as number,
            inAanmerkingTeNemenRenteVoorgaandeJaren: null as unknown as number,
            standGestaldeNietAftrekbareRente: null as unknown as number,
            naarVolgendJaarOverTeBrengenDeelnemingsVerrekening: null as unknown as number,
            boekJaarTerugwentelingVerliesBegindatum: null as unknown as Date,
            boekJaarTerugwentelingVerliesEinddatum: null as unknown as Date,
            saldoOnverrekendVerliesNaDitBoekjaar: null as unknown as number,
            verrekendVerliesBijAfgegevenBeschikking: null as unknown as number,
            bedragVanDeAanslag: null as unknown as number,
            verrekendeVoorlopigeAanslag: null as unknown as number,
            vergrijpBoete: null as unknown as number,
            belastingrente: null as unknown as number,
            teBetalenOfTeOntvangen: null as unknown as number,
            betalingsKorting: null as unknown as number,
            teBetalenNaToepassingBetalingsKorting: null as unknown as number,
            vennootschapsbelasting: null as unknown as number,
            saldInTeLopenVoortbrengingskostenEindeBoekjaar: null as unknown as number,
            totaaAftrekEldersBelast: null as unknown as number,
            verrekendeDeelnemingsverrekening: null as unknown as number,
            verrekendeBelastingBuitenlandseOndernemingswinst: null as unknown as number,
            overTeBrengenVerrekBelastingBuitenlOndernemingswinst: null as unknown as number,
            verrekendeBelastingBoordelenGecontroleerdLichaam: null as unknown as number,
            totaalBelastingverminderingen: null as unknown as number,
            saldoBelastingZonderVerrekeningVoorheffingen: null as unknown as number,
            verrekendeVoorheffingen: null as unknown as number,
            overTeBrengenVerrekeningVoorheffingen: null as unknown as number,
            herzieningVerliesToelichting: null as unknown as number,
            navorderingVerlies: null as unknown as number,
            verhogingBijNietTijdigeAangifte: null as unknown as number,
            invorderingVoorlopigTeruggaafVerlies: null as unknown as number,
            saldoBelastingVoorToepassingVermindering: null as unknown as number,
            saldoBelastingNaToepassingVermindering: null as unknown as number,
            nagevorderdeBelasting: null as unknown as number,
            teVerrekenenOfTerugTeGevenVoorToerekeningAanslag: null as unknown as number,
            totaalBelastingteruggaafIvmTerugwentelingVerlies: null as unknown as number,
            toeTeRekenenAanAndereAanslagen: null as unknown as number,
            toeTeRekenenAanDezeAanslag: null as unknown as number,
            eerderVastgesteldBelastingbedrag: null as unknown as number,
            nieuwVastgesteldBelastingbedrag: null as unknown as number,
            nieuwVastgesteldSaldoTeBetalenOfTerugTeOntvangen: null as unknown as number,
            eerderVastgesteldSaldoTeBetalenOfTerugTeOntvangen: null as unknown as number,
            verrekendeVoorlopigeTeruggaven: null as unknown as number,
            vergoedeBelastingrente: null as unknown as number,
            naw1Belastingplichtige: null as unknown as string,
            middel: null as unknown as string,
            aangifteJaar: null as unknown as number
        });
        this.formGroupBtw = this.fb.group({
            bedragAanslag: this.fb.group({
                bedragBoeteIcp: null as unknown as number,
                teBetalen: null as unknown as number,
                nieuwVastGesteldeBoete: null as unknown as number,
                eerderVastGesteldeBoete: null as unknown as number,
                teVerrekenenOfTerugTeOntvangen: null as unknown as number,
                teLaatBetaaldeOmzetbelasting: null as unknown as number,
                omzetbelastingVerschuldigd: null as unknown as number,
                omzetbelastingEersteAanslagSelectie: null as unknown as number,
                betaaldOpAangifte: null as unknown as number,
                verrekendOpUwVerzoek: null as unknown as number,
                openstaandBedrag: null as unknown as number,
                boeteWegensNietBetalen: null as unknown as number,
                boeteWegensTeLaatBetalen: null as unknown as number,
                boeteOmzetbelasting: null as unknown as number,
                aangifteBoete: null as unknown as number,
                nieuwVastGesteldeOmzetbelasting: null as unknown as number,
                nieuwVastGesteldRenteBedrag: null as unknown as number,
                nieuwVastGesteldTotaalBedrag: null as unknown as number,
                renteBedrag: null as unknown as number,
                nietBetaaldeOmzetbelasting: null as unknown as number,
                tijdigBetaaldeOmzetbelasting: null as unknown as number,
                eerderVastGesteldeOmzetbelasting: null as unknown as number,
                eerderVastGesteldRenteBedrag: null as unknown as number,
                eerderVastGesteldTotaalBedrag: null as unknown as number,
                verschilBedrag: null as unknown as number,
                naw1Belastingplichtige: null as unknown as string,
                middel: null as unknown as string,
                aangifteJaar: null as unknown as number
            })
        });
        this.formGroupTsl = this.fb.group({
            meldingen: this.fb.group({
                bedragVastgesteldInkomen: null as unknown as number
            }),
            regeling: this.fb.group({
                toeslagType: null as unknown as ToeslagType,
                beschikkingsTypeRegelniveau: null as unknown as BeschikkingsType,
                jaarBedragPerToeslag: null as unknown as number,
                jaarBedragRentePerToeslag: null as unknown as number,
                jaarBedragBoetePerToeslag: null as unknown as number,
                JaarbedragVorigPerToeslag: null as unknown as number,
                nogTeBetalen: null as unknown as number,
                nogTeOntvangen: null as unknown as number,
                renteTeBetalen: null as unknown as number,
                renteTeOntvangen: null as unknown as number,
                startDatumToeslag: null as unknown as number,
                eindDatumToeslag: null as unknown as number,
                totaalbedragTeBetalen: null as unknown as number,
                totaalbedragTeOntvangen: null as unknown as number,
                naw1Belastingplichtige: null as unknown as string,
                middel: null as unknown as string,
                aangifteJaar: null as unknown as number
            })
        });
    }

    public ibFields = [
        { formControlName: 'belastbaarInkomenUitWerkEnWoning', label: 'Inkomen box 1', prefix: '€' },
        { formControlName: 'belastbaarInkomenAanmerkelijkBelang', label: 'Inkomen box 2', prefix: '€' },
        { formControlName: 'belastbaarInkomenBox3', label: 'Inkomen box 3', prefix: '€' },
        { formControlName: 'verzamelinkomen', label: 'Verzamelinkomen', prefix: '€' },
        { formControlName: 'belastingBox1', label: 'Belasting box 1', prefix: '€' },
        { formControlName: 'saldoPremiesVolksverzekeringen', label: 'Premies volksverzekering', prefix: '€' },
        { formControlName: 'belastingBox2', label: 'Belasting box 2', prefix: '€' },
        { formControlName: 'belastingBox3', label: 'Belasting box 3', prefix: '€' },
        { formControlName: 'algemeneHeffingskortingBerekend', label: 'Algemene heffingskorting', prefix: '€' },
        { formControlName: 'arbeidsKortingBerekend', label: 'Arbeidskorting', prefix: '€' },
        { formControlName: 'inkomensafhankelijkeCombinatiekortingBerekend', label: 'IACK', prefix: '€' },
        { formControlName: 'jonggehandicaptenkortingBerekend', label: 'Wajong korting', prefix: '€' },
        { formControlName: 'ouderenKortingBerekend', label: 'Ouderenkorting', prefix: '€' },
        { formControlName: 'alleenstaandeOuderenKortingBerekend', label: 'Alleenstaande ouderenkorting', prefix: '€' },
        { formControlName: 'groeneBeleggingenKortingBerekend', label: 'Korting groene beleggingen', prefix: '€' },
        { formControlName: 'bedragVanDeAanslagNaToetsingAanslaggrens', label: 'Verschuldigde belasting', prefix: '€' },
        { formControlName: 'verrekendeDividendEnKansspelbelasting', label: 'Voorheffing dividendbelasting', prefix: '€ -' },
        { formControlName: 'teVerrekenenLoonbelastingPremieVolksverzekeringen', label: 'Voorheffing loonbelasting', prefix: '€ -' },
        { formControlName: 'teBetalenTerugTeOntvangen', label: 'Te betalen / te ontvangen', prefix: '€' },
    ];

    public zvwFields = [
        { formControlName: 'bijdrageInkomenAanslagZVW', label: 'Bijdrage-inkomen', prefix: '€' },
        { formControlName: 'bijdrageZvwAanslag', label: 'Bijdrage Zvw', prefix: '€' },
        { formControlName: 'totaalEerdereAanslagen', label: 'Totaal eerdere aanslagen', prefix: '€ -' },
        { formControlName: 'teBetalenTerugTeOntvangen', label: 'Totaal deze aanslag', prefix: '€' },
    ];

    public vpbFields = [
        { formControlName: 'belastbareWinst', label: 'Belastbare winst', prefix: '€' },
        { formControlName: 'verrekendVerliesDitBoekjaar', label: 'Verrekend verlies', prefix: '€ -' },
        { formControlName: 'belastbaarBedrag', label: 'Belastbaar bedrag', prefix: '€' },
        { formControlName: 'bedragVanDeAanslag', label: 'V', prefix: '€' },
        { formControlName: 'verrekendeVoorlopigeAanslag', label: 'Verrekende voorlopige aanslagen', prefix: '€' },
        { formControlName: 'vergrijpBoete', label: 'Vergrijpboete', prefix: '€' },
        { formControlName: 'belastingrente', label: 'Belastingrente', prefix: '€' },
        { formControlName: 'teBetalenOfTeOntvangen', label: 'Verschuldigd', prefix: '€' },
        { formControlName: 'betalingsKorting', label: 'Betalingskorting', prefix: '€' },
        { formControlName: 'teBetalenNaToepassingBetalingsKorting', label: 'Verschuldigd na betalingskorting', prefix: '€' },
    ];

    public btwFields = [
        { formControlName: 'nieuwVastGesteldeBoete', label: 'Nieuw vastgestelde bedrag', prefix: '€' },
        { formControlName: 'eerderVastGesteldeBoete', label: 'Eerder vastgestelde bedrag', prefix: '€' },
        { formControlName: 'totaalEerdereAanslagen', label: 'Totaal eerdere aanslagen', prefix: '€ -' },
        { formControlName: 'teVerrekenenOfTerugTeOntvangen', label: 'Totaal deze aanslag', prefix: '€' },
        { formControlName: 'boeteOmzetbelasting', label: 'Boete', prefix: '€' },
    ];

    public tslMeldingenFields = [
        { formControlName: 'bedragVastgesteldInkomen', label: 'Vastgesteld inkomen', prefix: '€' },
    ];

    public tslRegelingFields = [
        { formControlName: 'toeslagType', label: 'Toeslag type', prefix: '' },
        { formControlName: 'beschikkingsTypeRegelniveau', label: 'Beschikkingstype', prefix: '' },
        { formControlName: 'jaarBedragPerToeslag', label: 'Jaarbedrag', prefix: '€' },
        { formControlName: 'jaarBedragRentePerToeslag', label: 'Jaarbedrag rente', prefix: '€' },
        { formControlName: 'jaarBedragBoetePerToeslag', label: 'Jaarbedrag boete', prefix: '€' },
        { formControlName: 'JaarbedragVorigPerToeslag', label: 'Jaarbedrag vorig', prefix: '€' },
        { formControlName: 'nogTeBetalen', label: 'Nog te betalen', prefix: '€' },
        { formControlName: 'nogTeOntvangen', label: 'Nog te ontvangen', prefix: '€' },
        { formControlName: 'renteTeBetalen', label: 'Rente te betalen', prefix: '€' },
        { formControlName: 'renteTeOntvangen', label: 'Rente te ontvangen', prefix: '€' },
        { formControlName: 'startDatumToeslag', label: 'Startdatum', prefix: '' },
        { formControlName: 'eindDatumToeslag', label: 'Einddatum', prefix: '' },
        { formControlName: 'totaalbedragTeBetalen', label: 'Totaal te betalen', prefix: '€' },
        { formControlName: 'totaalbedragTeOntvangen', label: 'Totaal te ontvangen', prefix: '€' },
    ];

    hasValue(fieldName: string): boolean {
        const value = this.formGroupIb.get(fieldName)?.value;
        return value != null;
    }

    hasValueZvw(fieldName: string): boolean {
        return this.formGroupZvw.get(fieldName)?.value != null;
    }

    hasValueVpb(fieldName: string): boolean {
        return this.formGroupVpb.get(fieldName)?.value != null;
    }

    hasValueBtw(fieldName: string): boolean {
        return this.formGroupBtw.get('bedragAanslag')?.get(fieldName)?.value != null;
    }

    hasValueTslMeldingen(fieldName: string): boolean {
        return this.formGroupTsl.get('meldingen')?.get(fieldName)?.value != null;
    }

    hasValueTslRegeling(fieldName: string): boolean {
        return this.formGroupTsl.get('regeling')?.get(fieldName)?.value != null;
    }

    ngOnInit(): void {
        this.algDataService.serviceBerichtXbrl
            .pipe(takeUntil(this.destroy$))
            .subscribe(value => {
                if (value) {
                    this.serviceBerichtXbrl = value;
                    const ophaal = this.berichtSoortBepalerVoorPdf(value);
                    this.berichtenService.converteerXbrlToJson(ophaal).subscribe((data) => {
                        console.log(data);
                        this.isIb = false;
                        this.isZvw = false;
                        this.isVpb = false;
                        this.isBtw = false;
                        this.isTsl = false;
                        if (ophaal.berichtsoort === 'IB') {
                            this.sbaIb = data;
                            this.formGroupIb.patchValue(data);
                            this.isIb = true;
                        }
                        if (ophaal.berichtsoort === 'ZVW') {
                            this.sbaZvw = data;
                            this.formGroupZvw.patchValue(data);
                            this.isZvw = true;
                        }
                        if (ophaal.berichtsoort === 'VPB') {
                            this.sbaVpb = data;
                            this.formGroupVpb.patchValue(data);
                            this.isVpb = true;
                        }
                        if (ophaal.berichtsoort === 'TSG') {
                            this.sbaTsl = data;
                            this.formGroupTsl.patchValue(data);
                            this.isTsl = true;
                        }
                        if (ophaal.berichtsoort === 'OB') {
                            this.sbaBtw = data;
                            this.formGroupBtw.patchValue(data);
                            this.isBtw = true;
                        }
                    });
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    berichtSoortBepalerVoorPdf(xbrl: string): OphaalResponse {
        let ophaalResponse = {} as OphaalResponse;
        if (xbrl.includes('bd-rpt-ih-sba')) {
            ophaalResponse = {
                inhoud: btoa(xbrl),
                berichtsoort: 'IB'
            };
        } else if (xbrl.includes('bd-rpt-zvw-sba')) {
            ophaalResponse = {
                inhoud: btoa(xbrl),
                berichtsoort: 'ZVW'
            };
        } else if (xbrl.includes('bd-rpt-vpb-sba')) {
            ophaalResponse = {
                inhoud: btoa(xbrl),
                berichtsoort: 'VPB'
            };
        } else if (xbrl.includes('bd-rpt-tsl-sbt')) {
            ophaalResponse = {
                inhoud: btoa(xbrl),
                berichtsoort: 'TSG'
            };
        } else if (xbrl.includes('bd-rpt-ihz-via')) {
            ophaalResponse = {
                inhoud: btoa(xbrl),
                berichtsoort: 'VIA'
            };
        } else if (xbrl.includes('bd-rpt-ob-sba')) {
            ophaalResponse = {
                inhoud: btoa(xbrl),
                berichtsoort: 'OB'
            };
        } else if (xbrl.includes('uitstel-sba')) {
            ophaalResponse = {
                inhoud: btoa(xbrl),
                berichtsoort: 'BECON'
            };
        }
        return ophaalResponse;
    }

    getNaamIb(): string {
        const naam = this.formGroupIb.value.naw1Belastingplichtige || '';
        return `${naam}`.trim();
    }

    getMiddelIb(): string {
        const middel = this.formGroupIb.value.middel || '';
        const jaar = this.formGroupIb.value.aangifteJaar || '';
        return `${middel} ${jaar}`.trim();
    }

    getNaamZvw(): string {
        const naam = this.formGroupZvw.value.naw1Belastingplichtige || '';
        return `${naam}`.trim();
    }

    getMiddelZvw(): string {
        const middel = this.formGroupZvw.value.middel || '';
        const jaar = this.formGroupZvw.value.aangifteJaar || '';
        return `${middel} ${jaar}`.trim();
    }

    getNaamBtw(): string {
        const naam = this.formGroupBtw.value.naw1Belastingplichtige || '';
        return `${naam}`.trim();
    }

    getMiddelBtw(): string {
        const middel = this.formGroupBtw.value.middel || '';
        const jaar = this.formGroupBtw.value.aangifteJaar || '';
        return `${middel} ${jaar}`.trim();
    }

    getNaamVpb(): string {
        const naam = this.formGroupVpb.value.naw1Belastingplichtige || '';
        return `${naam}`.trim();
    }

    getMiddelVpb(): string {
        const middel = this.formGroupVpb.value.middel || '';
        const jaar = this.formGroupVpb.value.aangifteJaar || '';
        return `${middel} ${jaar}`.trim();
    }

    getNaamTsl(): string {
        const naam = this.formGroupTsl.value.naw1Belastingplichtige || '';
        return `${naam}`.trim();
    }

    getMiddelTsl(): string {
        const middel = this.formGroupTsl.value.middel || '';
        const jaar = this.formGroupTsl.value.aangifteJaar || '';
        return `${middel} ${jaar}`.trim();
    }


}
